// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Dungeon-dimensions Universe - Aliens Configuration
 * 
 * IMPORTANT: This file only contains the planet-to-alien mapping.
 * All alien definitions are in src/config/AlienSpeciesConfig.js
 * 
 * Workflow:
 * 1. Add alien to AlienSpeciesConfig.js first
 * 2. Then map it to planets here
 */

export const DungeonDimensionsAliensPlanets = {
  // Planet-specific alien populations
  planets: {
    // THE SCREAMING VOID (100) - Entry point to madness
    100: ['ancients', 'energybeings'],
    
    // IMPOSSIBLE ANGLES (101) - Non-Euclidean geometry
    101: ['ancients', 'photonic', 'energybeings'],
    
    // MATHEMATICS BREAKDOWN ZONE (102) - Where 2+2=purple
    102: ['ancients', 'crystalline'],
    
    // LOGIC BREAKDOWN (103) - Where reason goes to die
    103: ['ancients', 'hivemind', 'crystalline'],
    
    // REALITY FAULT LINE (104) - Cracks in existence
    104: ['ancients', 'energybeings', 'photonic'],
    
    // THE UNTHINKABLE (105) - Concepts that shouldn't exist
    105: ['ancients', 'hivemind'],
    
    // PROBABILITY STORM (106) - Chaos incarnate
    106: ['ancients', 'energybeings'],
    
    // TEMPORAL PARADOX NEXUS (107) - Time eating its own tail
    107: ['ancients', 'photonic', 'energybeings'],
    
    // CAUSALITY LOOP (108) - Effects preceding causes
    108: ['ancients', 'energybeings', 'crystalline'],
    
    // CONCEPTUAL VOID (109) - Where ideas go to die
    109: ['ancients', 'crystalline'],
    
    // THE UNSPEAKABLE (110) - Better left unnamed
    110: ['ancients', 'energybeings', 'hivemind'],
    
    // DUNGEON DIMENSIONS NEXUS (111) - Heart of the dimensions
    111: ['ancients', 'energybeings', 'crystalline', 'hivemind'],
    
    // NARRATIVE COLLAPSE (112) - Stories unraveling
    112: ['ancients', 'photonic', 'energybeings'],
    
    // THE DUNGEON HEART (113) - Core of the dimensions
    113: ['ancients', 'energybeings', 'crystalline', 'photonic', 'hivemind']
  },
  
  // Random encounter aliens - mostly eldritch horrors
  randomEncounters: [
    'ancients',
    'energybeings',
    'photonic',
    'crystalline',
    'hivemind'
  ],
  
  // Hostile aliens - most things here are dangerous
  hostileSpecies: [
    'ancients',    // Ancient evils
    'hivemind',    // Collective consciousness
    'energybeings' // Chaotic entities
  ],
  
  // Friendly traders - very few in this realm
  friendlyTraders: [
    'crystalline', // Geometric entities might trade in concepts
    'photonic'     // Light beings might be neutral
  ]
};

export default DungeonDimensionsAliensPlanets;
